/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import { closelightbox } from "../../util/Functions";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Grid, TextField, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const SuccessAssign = (props) => {
  const [data, setData] = useState([
    {key: "spaceUuid", label: "UUID espacio"},
    {key: "clabe", label: "CLABE"},
    {key: "cashin", label: "Referencia cashin"},
  ]);

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Asignación Correcta
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent sx={{paddingBottom: "0px" }}>
          <Grid container spacing={2} sx={{paddingTop: "10px"}}>
            {data.map((item, index) => {
              return (
                props.contentModal[item.key] && 
                  <Grid container spacing={2} key={index}  sx={{margin: "auto"}}>
                    <Grid item xs={12} sx={{color: "#969BA0"}}>{item.label}:</Grid>
                    <Grid item xs={12} sx={{paddingTop: "0px !important"}}>{props.contentModal[item.key]}</Grid>
                  </Grid>                
              )})}
          </Grid>
        </DialogContent>

        <DialogActions>					
          <Button variant="contained" onClick={closelightbox} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default SuccessAssign;
